<rcl-text-field
	[group]="emailForm"
	[type]="'text'"
	[label]="(resourceBundle.bundle | async)['ctc.email.label']"
	[control]="'email'"
></rcl-text-field>

<rcl-error-message *ngFor="let error of errors.email">{{ error }}</rcl-error-message>
